import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import React from "react";

import EightStoriesWithAdWidget from "../rows/eight-stories-with-ad-widget";
import FourStoryWithAd from "../rows/four-story-with-ad";
import TwoCollectionWithTwoStories from "../rows/two-collections-with-two-stories";
import SingleStoryWithAd from "../rows/single-story-with-ad";
import VideoScroller from "../rows/video-scroller";
import Explainer from "../rows/explainer";
import BigStoryCollections from "../rows/big-story-collections";
import QuintLens from "../rows/quint-lens";
import SixStoryWithSeeMoreAd from "../rows/six-story-with-seemore-ad";
import Snapshot from "../rows/snapshot";
import LoadMoreStoryMixedCollection from "../rows/loadmore-story-mixed-collection";

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={(token) => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  return wrappedComponent;
}

export default {
  EightStoriesWithAdWidget: wrapEager(wrapCollectionLayout(EightStoriesWithAdWidget)),
  FourStoryWithAd: wrapEager(wrapCollectionLayout(FourStoryWithAd)),
  TwoCollectionWithTwoStories: wrapEager(wrapCollectionLayout(TwoCollectionWithTwoStories)),
  SingleStoryWithAd: wrapEager(wrapCollectionLayout(SingleStoryWithAd)),
  VideoScroller: wrapEager(wrapCollectionLayout(VideoScroller)),
  Explainer: wrapEager(wrapCollectionLayout(Explainer)),
  BigStoryCollections: wrapEager(wrapCollectionLayout(BigStoryCollections)),
  QuintLens: wrapEager(wrapCollectionLayout(QuintLens)),
  SixStoryWithSeeMoreAd: wrapEager(wrapCollectionLayout(SixStoryWithSeeMoreAd)),
  Snapshot: wrapEager(wrapCollectionLayout(Snapshot)),
  LoadMoreStoryMixedCollection: wrapEager(wrapCollectionLayout(LoadMoreStoryMixedCollection)),
  defaultTemplate: wrapEager(wrapCollectionLayout(SixStoryWithSeeMoreAd)),
};
